import { React, useState, Typography, Box, CustomButton, Dayjs, dayjs } from "../../utils/globalImports";
import { useApi, CustomDataTableModal } from "../../utils/globalImports";

interface ViewFrameworkProps {
    data: Framework[];
    name: string;
}

interface Framework {
    frameworkId: number;
    frameworkName: string;
    clientId: number;
    clientName: string;
    status: boolean;
    projectNames: string;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}


const ViewFramework: React.FC<ViewFrameworkProps> = ({ data, name }) => {
    const [frameworkOption, setFrameworkOption] = useState<any[]>([]);
    const [modalOpen, setModalOpen] = useState(false);

    const handleViewFramework = () => {
        setModalOpen(true)
        const frameworkOption = data
            .filter(framework => framework.status) // Filter for active framework
            .map((framework) => ({
                frameworkName: framework.frameworkName,
                associatedClients: framework.clientName,
                endDate: framework.endDate ? dayjs(framework.endDate).format("DD/MM/YYYY") : 'N/A',
                status: framework.status ? 'Active' : 'Inactive',
            }));
        setFrameworkOption(frameworkOption)
    }


    return (
        <Box
            sx={{
                width: "205%",
                backgroundColor: "#ffffff",
                borderRadius: "50px",
                boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.35)",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 0,
                mb: 2,
            }}
        >
            <Typography sx={{ color: "#1e66ab", fontWeight: 600 }}>
                {
                    name
                }
            </Typography>
            <CustomButton
                sx={{
                    textTransform: "none",
                    width: "25%",
                    borderRadius: "50px",
                }}
                // disabled={frameworkId <= 0 ? true : false}
                onClick={() =>
                    handleViewFramework()
                }
                type="button"
            >
                View Frameworks
            </CustomButton>
            <CustomDataTableModal
                rows={frameworkOption}
                columns={[
                    { field: "frameworkName", headerName: "Framework Name" },
                    {
                        field: "associatedClients",
                        headerName: "Associated Clients",
                    },
                    { field: "endDate", headerName: "End Date" },
                    { field: "status", headerName: "Status" },
                ]}
                actionText="framework"
                heading={`${name}  Framework`}
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </Box>
    );
}

export default ViewFramework;
